/**
 * Premier "Base N" libre parmi les libellés déjà pris.
 *
 * Préféré à un `length + 1` : après une suppression, ce dernier reproposerait un nom déjà utilisé.
 * Même convention que `themeStore._nextThemeName`, dont ce helper généralise le calcul.
 */
export default function nextFreeLabel(
	base: string,
	taken: string[],
	options?: {
		/** Numérote dès le premier : "Type 1" plutôt que "Type". Pour un nom générique, qui n'a de sens
		 * qu'accompagné d'un rang ; inutile pour un nom qui se suffit à lui-même, comme la nature d'un
		 * champ ("Texte", puis "Texte 2"). */
		numberFirst?: boolean;
	},
): string {
	if (!options?.numberFirst && !taken.includes(base)) return base;

	for (let n = options?.numberFirst ? 1 : 2; ; n++) {
		const candidate = `${base} ${n}`;

		if (!taken.includes(candidate)) return candidate;
	}
}
